import { TextIcon } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import ParagraphEditorRenderer from "./editor";
import ParagraphEmailRenderer from "./email";
import { ParagraphEmailPanelRenderer } from "./email-panel";
import type { ParagraphBlock, ParagraphBlockProps } from "./types";
import ParagraphWeb from "./web";
import { ParagraphWebEditor } from "./web-editor";

export default registerBlock<ParagraphBlockProps>({
  type: "paragraph",
  name: "editorBlocksLibrary.blocks.paragraph.title",
  description: "editorBlocksLibrary.blocks.paragraph.description",
  Icon: TextIcon,
  category: BlockCategory.ESSENTIALS,
  isTranslated: (locale, block) => {
    const content = (block as ParagraphBlock).content;
    const html = content?.[locale]?.html ?? "";

    // A paragraph counts as translated when it has visible text OR an image:
    // stripping tags to check for text alone misses image-only paragraphs
    // (used to get a per-language image for free).
    const hasText = html.replace(/<[^>]+>/g, "").trim().length > 0;
    const hasImage = /<img\b/i.test(html);

    return !!content && (hasText || hasImage);
  },
  components: {
    email: {
      component: ParagraphEmailRenderer,
      editor: {
        component: ParagraphEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ParagraphEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: true,
      },
    },
    web: {
      component: ParagraphWeb,
      editor: {
        component: ParagraphWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ParagraphEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: true,
      },
    },
  },
});

export type {
  ParagraphBlock,
  ParagraphBlockProps as ParagraphEditorRendererProps,
} from "./types";
